var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _RecursiveTaskPlannedJournalEvent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo } from "@ember-data/model";
import { default as JournalEvent, default as JournalEventModel } from "core/models/journal-event";
import tWithDefault from "core/utils/t-with-default";
import dayjs, { Dayjs, ManipulateType } from "dayjs";
import { validateDate, validateInclusion, validateNumber, validatePresence } from "ember-changeset-validations/validators";
import { IntlService } from "ember-intl";
import Patient from "./patient";
import TreatmentHistoryChangedJournalEvent from "./treatment-history-changed-journal-event";

//---- Automatically generated, don't update this part ----
/**
 * Represents a task that repeats over time
 */
let RecursiveTaskPlannedJournalEvent = (_dec = attr("date"), _dec2 = attr("number"), _dec3 = attr("string"), _dec4 = attr("string"), _dec5 = attr("string"), _dec6 = attr("number"), _dec7 = attr("string"), _dec8 = attr("boolean", {
  allowNull: true
}), _dec9 = attr("string"), _dec10 = attr("date"), _dec11 = belongsTo("treatment-history-changed-journal-event", {
  async: false,
  inverse: "recursiveTaskPlannedJournalEvents"
}), _dec12 = belongsTo("patient", {
  async: false,
  inverse: "recursiveTaskPlannedJournalEvents"
}), _class = (_RecursiveTaskPlannedJournalEvent = class RecursiveTaskPlannedJournalEvent extends JournalEvent {
  constructor(...args) {
    super(...args);
    /**
     * The date where the recursivity stops
     */
    _initializerDefineProperty(this, "endDate", _descriptor, this);
    /**
     * The number of time-frequency-unit
     */
    _initializerDefineProperty(this, "timeFrequencyValue", _descriptor2, this);
    /**
     * The time unit used (days, months, weeks ...)
     */
    _initializerDefineProperty(this, "timeFrequencyUnit", _descriptor3, this);
    /**
     * An identifier to be able to link the task to a JournalEvent field (mainly used by TreatmentHistoryJournalEvent)
     */
    _initializerDefineProperty(this, "originTaskIdentifier", _descriptor4, this);
    /**
     * The type of the responsible. Could be null.
     */
    _initializerDefineProperty(this, "responsibleType", _descriptor5, this);
    /**
     * The id of the responsible, could be null
     */
    _initializerDefineProperty(this, "responsibleId", _descriptor6, this);
    /**
     * An id describing the nature of the task.
     */
    _initializerDefineProperty(this, "taskType", _descriptor7, this);
    /**
     * A boolean to remind the responsible to do the task
     */
    _initializerDefineProperty(this, "remindResponsible", _descriptor8, this);
    /**
     * A JournalEvent type that will process the task automatically after a JE creation. Could be a CompoundSurvey's id if the taskType is "compound-survey".
     * This should be written in snake case.
     * Example: 'weight-measured-journal-event'
     */
    _initializerDefineProperty(this, "processingJournalEventType", _descriptor9, this);
    /**
     * Represents the last time an occurrence has been processed
     */
    _initializerDefineProperty(this, "processedAt", _descriptor10, this);
    _initializerDefineProperty(this, "treatmentHistoryChangedJournalEvent", _descriptor11, this);
    //---- End of generated code ----
    _initializerDefineProperty(this, "patient", _descriptor12, this);
  }
  static validations(intl) {
    return {
      occurredAt: [validatePresence({
        presence: true,
        description: tWithDefault(intl, "validations.recursive-task-planned-journal-event.occurred-at", "La date")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
        onOrAfter: new Date("01/01/1900")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée plus de 50 ans en avance. Veuillez modifier la date",
        onOrBefore: dayjs().add(50, "years").toDate()
      })],
      timeFrequencyValue: validateNumber({
        allowBlank: true,
        description: intl.t("validations.recursive-task-planned-journal-event.time-frequency-value")
      }),
      responsibleId: validateNumber({
        allowBlank: true,
        integer: true,
        description: intl.t("validations.recursive-task-planned-journal-event.responsible-id")
      }),
      responsibleType: validateInclusion({
        list: ["patient"],
        allowBlank: true,
        description: intl.t("validations.recursive-task-planned-journal-event.responsible-type")
      })
    };
  }
  get lastOrNextUnprocessedTask() {
    if (!this.processedAt) return this.createTaskAt(this.occurredAt);
    const date = this.nextDateFrom(this.processedAt, true);
    return this.createTaskAt(date);
  }
  get nextTask() {
    return this.createTaskAt(this.nextDateFrom(dayjs()));
  }
  get lastTask() {
    return this.allTasks.reverse().find(task => dayjs().isBefore(task.occurredAt));
  }
  get allTasks() {
    return this.tasksBetween(this.occurredAt, this.endDate || dayjs().add(1, "year"));
  }
  get processedTask() {
    return this.tasksBetween(this.occurredAt, this.processedAt);
  }
  tasksBetween(startDate, endDate) {
    return this.taskDatesBetween(startDate, endDate).map(occurredAt => this.createTaskAt(occurredAt)).filter(t => Boolean(t));
  }
  taskDatesBetween(startDate, endDate) {
    const taskDates = [];
    const loopEnd = this.endDate && dayjs(endDate).isAfter(this.endDate) ? this.endDate : endDate;
    let currentDate = dayjs(this.occurredAt);
    while (currentDate.isBetween(this.occurredAt, loopEnd, "day", "[]")) {
      if (currentDate.isBetween(startDate, endDate, "day", "[]")) {
        taskDates.push(currentDate.toDate());
      }
      currentDate = currentDate.add(this.timeFrequencyValue, this.timeFrequencyUnit);
    }
    return taskDates;
  }
  nextDateFrom(startDate, excludeStartDay = true) {
    const loopEnd = this.endDate || dayjs().add(1, "year");
    let currentDate = dayjs(this.occurredAt);
    while (currentDate.isBetween(this.occurredAt, loopEnd, "day", "[]")) {
      if (excludeStartDay ? currentDate.isAfter(startDate, "day") : currentDate.isSameOrAfter(startDate, "day")) {
        return currentDate.toDate();
      }
      currentDate = currentDate.add(this.timeFrequencyValue, this.timeFrequencyUnit);
    }
    return undefined;
  }
  createTaskAt(occurredAt) {
    if (!occurredAt) return;
    return {
      isRecursiveTask: true,
      id: this.id,
      occurredAt,
      taskType: this.taskType,
      patient: this.patient,
      remindResponsible: this.remindResponsible,
      responsibleId: this.responsibleId,
      responsibleType: this.responsibleType,
      processingJournalEventType: this.processingJournalEventType,
      originTaskIdentifier: this.originTaskIdentifier,
      originJournalEvent: this.originJournalEvent,
      taskLabel: this.intl.t(`task.types.${this.taskType}`)
    };
  }
}, _defineProperty(_RecursiveTaskPlannedJournalEvent, "type", "recursive-task-planned-journal-event"), _RecursiveTaskPlannedJournalEvent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "endDate", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "timeFrequencyValue", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "timeFrequencyUnit", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "originTaskIdentifier", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "responsibleType", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "responsibleId", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "taskType", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "remindResponsible", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "processingJournalEventType", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "processedAt", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "treatmentHistoryChangedJournalEvent", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "patient", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { RecursiveTaskPlannedJournalEvent as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.